export default "__VITE_ASSET__CCSh3CBK__"